import {
  defaultRelationFilter,
  type Filter,
} from '@/components/table-filters/constants';
import {
  IndustrialPremisesConfig,
  IndustrialPremisesContractConfig,
} from '@pigello/pigello-matrix';
import baseFilters, {
  baseGlobalRealEstatesFilter,
  baseTagFilter,
} from '../../filters';
import baseContractFilters from '../components/base-contract-filters';
import { Icons } from '@/components/icons';

const industrialPremisesContractFilters: Filter[] = [
  {
    ...defaultRelationFilter,
    title: IndustrialPremisesContractConfig.fields.space.verboseName,
    relationModelName: IndustrialPremisesConfig.modelName,
    externalFieldName:
      IndustrialPremisesContractConfig.fields.space.externalFieldName,
    icon: Icons.industrialpremisescontract,
  },
  ...baseGlobalRealEstatesFilter,
  ...baseContractFilters,
  ...baseTagFilter,
  ...baseFilters,
];

export default industrialPremisesContractFilters;
